import isLocalStorageAvailable from './mini/isLocalStorageAvailable';

const lsRunCopiedVersionOnProdTooltipKey = 'alan-show-run-copied-version-on-prod-tooltip';
const lsDocsTooltipKey = 'alan-show-doc-tooltip';
const lsCmdSTooltipKey = 'alan-show-cmd-s-tooltip';
const lsZoomTooltipKey = 'alan-show-zoom-tree-tooltip';

export function shouldShowTooltip(tooltipKey) {
    return isLocalStorageAvailable() ?
        (localStorage.getItem(tooltipKey) === 'false' ? false : true) :
        true;
}

export function saveTooltipState(tooltipKey) {
    if (isLocalStorageAvailable()) {
        localStorage.setItem(tooltipKey, false);
    }
}

const tooltipService = {

    shouldShowRunCopiedVersionOnProdTooltip: function () {
        return shouldShowTooltip(lsRunCopiedVersionOnProdTooltipKey);
    },

    shouldShowDocsTooltip: function () {
        return shouldShowTooltip(lsDocsTooltipKey);
    },

    shouldShowCmdSTooltip: function () {
        return shouldShowTooltip(lsCmdSTooltipKey);
    },

    saveDocsTooltipState: function () {
        saveTooltipState(lsDocsTooltipKey);
    },

    saveRunCopiedVersionOnProdTooltipState: function () {
        saveTooltipState(lsRunCopiedVersionOnProdTooltipKey);
    },

    saveCmdSTooltipState: function () {
        saveTooltipState(lsCmdSTooltipKey);
    },

    shouldShowZoomTreeTooltip: function () {
        return shouldShowTooltip(lsZoomTooltipKey);
    },

    saveZoomTreeTooltipState: function () {
        saveTooltipState(lsZoomTooltipKey);
    }
};
export default tooltipService;
